
import { setPlanningShiftTableLoading } from '@/entities/gridTables/slices/planningShiftTablesSlice'
import { setRunsheetShiftTableLoading } from '@/entities/gridTables/slices/runsheetShiftTablesSlice'
import { updatePlanningShiftTableState } from '@/entities/gridTables/thunks/updatePlanningShiftTableState'
import { updateRunsheetShiftTableState } from '@/entities/gridTables/thunks/updateRunsheetShiftTableState'
import { CurrentScreenType } from '@/entities/userInterface/model/CurrentScreenType'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { PlanningShift } from '../models/planning/PlanningShift'
import { RunsheetShift } from '../models/runsheet/RunsheetShift'
import { fetchRunsheets } from './fetchRunsheets'
import { fetchScenarios } from './fetchScenarios'

type UpdateShiftStartTimePayload = {
  type: CurrentScreenType
  startTime: string
  shiftId: EntityId
  scheduleId: EntityId
  isNextDay: boolean
}

export const updateShiftStartTime = createAsyncThunk<void, UpdateShiftStartTimePayload, ThunkApiContext>(
  'schedule/updateShiftStartTime',
  async ({ scheduleId, ...payload }, { getState, dispatch }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/updateStartTime' : '/runsheet/updateStartTime'

    if (currentScreen === 'planning') {
      dispatch(setPlanningShiftTableLoading({ id: payload.shiftId, isLoading: true }))
      await OLMSApiService.post<PlanningShift>(endpoint, payload)
      await dispatch(fetchScenarios({ scenarioIds: [scheduleId] }))
      await dispatch(updatePlanningShiftTableState({ shiftId: payload.shiftId }))
      dispatch(setPlanningShiftTableLoading({ id: payload.shiftId, isLoading: false }))
    }
    else {
      dispatch(setRunsheetShiftTableLoading({ id: payload.shiftId, isLoading: true }))
      await OLMSApiService.post<RunsheetShift>(endpoint, payload)
      await dispatch(fetchRunsheets({ runsheetIds: [scheduleId] }))
      await dispatch(updateRunsheetShiftTableState({ shiftId: payload.shiftId }))
      dispatch(setRunsheetShiftTableLoading({ id: payload.shiftId, isLoading: false }))
    }
  },
)
